(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-premium"] && !Shopify.designMode) return;
  try {
    
function initOtPremium(scope) {
  scope.querySelectorAll('.otp-page').forEach(page => {
    if (page.dataset.ready) return;
    page.dataset.ready = 'true';
    if (!('IntersectionObserver' in window)) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!motion.matches) entry.target.classList.add('otp-arrived');
        observer.unobserve(entry.target);
      }
    }), {threshold: 0.12});
    page.querySelectorAll('.otp-reveal').forEach(el => observer.observe(el));
    const sticky = page.querySelector('.otp-sticky');
    const hero = page.querySelector('.otp-hero');
    const final = page.querySelector('.otp-final');
    let pastHero = false;
    let nearEnd = false;
    const update = () => {
      const overlay = document.querySelector('dialog[open], [aria-modal="true"], #shopify-pc__banner');
      sticky.hidden = !pastHero || nearEnd || !!overlay || !!document.activeElement?.matches('input,textarea,select') || !!window.Shopify?.designMode;
    };
    const positionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        if (entry.target === final) nearEnd = entry.isIntersecting || entry.boundingClientRect.bottom < 0;
      });
      update();
    });
    positionObserver.observe(hero);
    positionObserver.observe(final);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    document.addEventListener('click', () => requestAnimationFrame(update));
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(page)) { observer.disconnect(); positionObserver.disconnect(); }
    }, {once:true});
  });
}
initOtPremium(document);
document.addEventListener('shopify:section:load', event => initOtPremium(event.target));

  } catch(e) { console.error(e); }
})();
})();
